import React from 'react';
import type { ReactElement, FC } from 'react';
import { QuestionMarkIcon } from '../icons/index.js';
import { Text } from './Text.js';

interface InputLabelProps {
  children: string;
  icon?: ReactElement;
}

export const InputLabel: FC<InputLabelProps> = ({ children, icon }) => {
  return (
    <Text>
      {icon ?? (
        <Text skin="question" bold>
          <QuestionMarkIcon />
        </Text>
      )}{' '}
      <Text skin="question" bold>
        {children}
      </Text>
    </Text>
  );
};
